import { Injectable } from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment'; 
import { ProvinciaModel } from '../../models/provincia.model';


@Injectable({
  providedIn: 'root'
})
export class ProvinciasService {
  url: string;

  constructor(protected http: HttpClient) { 
    this.url = environment.urlApi + '/provincias';
    console.log(environment.urlApi);
  }
  getProvincias(apikey: string, hash: string): Observable<ProvinciaModel[]> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
      headers = headers.append('accept', 'application/json'); 
      headers = headers.append('xApiKeyPublic', apikey);
      console.log(this.url);
      console.log(headers);
    return this.http.get<ProvinciaModel[]>(this.url,{headers});
  }

}
